import { IAvailableTwoWayCampaign, IHttpResponse } from '@gr/shared/models';
import { useQuery } from '@tanstack/react-query';
import { axiosGet } from '../authAxios';

export default function useTwoWayAvailableCampaigns() {
  const query = useQuery({
    queryKey: ['twoWayAvailableCampaigns'],
    queryFn: async () => {
      const response = await axiosGet<IHttpResponse<IAvailableTwoWayCampaign[]>>('/two-way-convos/available-campaigns');
      return response.data?.data ?? [];
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
  return { query };
}
